import Onboarding from './pages/Onboarding';
import CryptoWaitingListPersonal from './pages/CryptoWaitingListPersonal';
import CryptoWaitingList from './pages/CryptoWaitingList';
import GroupOffers from './pages/GroupOffers';
import PersonalChallenge from './pages/PersonalChallenge';
import Rabotnik from './pages/Rabotnik';
import ScratchPrize from './pages/ScratchPrize';
import Challenge from './pages/Challenge';
import InvitePage from './pages/InvitePage';
import InviteLeaderboardPage from './pages/InviteLeaderboardPage';
import InviteClubPage from './pages/InviteClubPage';
const createRoutes = () => [
    // CryptoOnboarding
    {
        path: '/app/crypto-onboarding',
        exact: true,
        component: Onboarding,
    },
    // CryptoWaitingList
    {
        path: '/app/cwl/:username/:listId',
        component: CryptoWaitingListPersonal,
    },
    {
        path: '/app/crypto-waiting-list',
        component: CryptoWaitingList,
    },
    // GroupOffers
    {
        path: '/app/go/:username/:offerId/:groupId',
        component: GroupOffers,
    },
    // PersonalChallenge
    {
        path: '/app/pc/:username/:challenge_id',
        component: PersonalChallenge,
    },
    // Rabotnik
    {
        path: '/app/company/:code',
        component: Rabotnik,
    },
    // ScratchPrize
    {
        path: '/app/sf/:username/',
        component: ScratchPrize,
    },
    // Challenge
    {
        path: '/app/race/:username/:challenge_id',
        component: Challenge,
    },
    {
        path: '/app/walkathon/:username/:challenge_id',
        component: Challenge,
    },
    // Get5Now
    {
        path: '/g5n/:username',
        exact: true,
        component: InvitePage,
        params: { feature: 'g5n_invite' },
        cookies: false,
        caching: true,
    },
    // Wallet
    {
        path: '/wal/:username',
        exact: true,
        component: InvitePage,
        params: { feature: 'wallet_invite' },
        cookies: false,
        caching: true,
    },
    // Daily Reward
    {
        path: '/dr/:username',
        exact: true,
        component: InvitePage,
        params: { feature: 'daily_reward_invite' },
        cookies: false,
        caching: true,
    },
    // Piggybank Invite
    {
        path: '/pb/:username',
        exact: true,
        component: InvitePage,
        params: { feature: 'piggybank_invite' },
        cookies: false,
        caching: true,
    },
    // Leaderboard
    {
        path: '/app/lb/:username',
        exact: true,
        component: InviteLeaderboardPage,
        params: { feature: 'leaderboard_invite' },
        cookies: false,
        caching: true,
    },
    // Clubs
    {
        path: '/app/c/:handle',
        exact: true,
        component: InviteClubPage,
        params: { feature: 'club_invite' },
        cookies: false,
        caching: true,
    },
];
export default createRoutes;
